// export const API_BASE_URL = "http://192.168.50.223:8000/api/";
// export const Image_BASE_URL = "https://localhost:7207/";

export const API_BASE_URL = "https://sparksapis.tripple9.com/api/";
export const Image_BASE_URL = "https://sparksapis.tripple9.com/storage/app/public/";


export const endpoints = {
  login: "Login/Login",
  forgotPassowrd: "Login/ForgotPassword",
  verifyOtp: "Login/VerifyOtp",
  resetPassword: "Login/ResetPassword",
  createUser: "Login/AddUser",
  SaveEnquiry: "Enquiry/SaveEnquiry",
  GetEnquiry: "Enquiry/GetEnquiry",
  GetEnquiryLoginId: "Enquiry/GetEnquiryLoginId",

  GetServiceType: "ServiceType/GetServiceType",
  GetServiceTypeContact: "ServiceType/GetServiceTypeContact",
  GetHouseStatus: "HouseStatus/GetHouseStatus",
  SaveServiceType: "ServiceType/SaveServiceType",
  DeleteServiceTypeById: "ServiceType/DeleteServiceTypeById",
  GetServiceTypeAll: 'ServiceType/GetServiceTypeAll',
  ActiveServiceTypeById: "/ServiceType/ActiveServiceTypeById",

  // /ServiceType/ActiveServiceTypeById?pServiceTypeId=1

  SaveBookAppoinment: "BookAppoinment/SaveBookAppoinment",
  GetBookAppoinment: "BookAppoinment/GetBookAppoinment",

  GetDashboardData: "Dashboard/MonthlyData",

  GetBookAppoinmentByLoginId: "BookAppoinment/GetBookAppoinmentByLoginId",

  SaveClubMembership: "ClubMembership/SaveClubMembership",
  GetClubMembership: "ClubMembership/GetClubMembership",

  SaveSizeType: "SizeType/SaveSizeType",
  GetSizeType: "SizeType/GetSizeType",
  GetSizeTypeAll: "SizeType/GetSizeTypeAll",
  GetSizeTypeByServiceId: "SizeType/get_size_type",
  DeleteSizeTypeById: "SizeType/DeleteSizeTypeById",


  GetSizeTypeDetails: "SizeType/get_size_type_details",
  GetSizeDetailTypeAll: "SizeTypeDetail/GetSizeDetailTypeAll",
  SaveSizeTypeDetails: "SizeTypeDetail/SaveSizeTypeDetails",
  DeleteSizeTypeDetailById: "SizeTypeDetail/DeleteSizeTypeDetailById",

  // https://sparkapi.lifecode.co.in/api/SizeTypeDetail/DeleteSizeTypeDetailById?detail_id=1
  // https://sparkapi.lifecode.co.in/api/SizeTypeDetail/SizeTypeDetailById?detail_id=7

  SaveQuatation: "Quatation/SaveQuatation",
  GetQuatation: "Quatation/GetQuatation",
  UpdateStatusQuatationById: "Quatation/UpdateStatusQuatationById",
  updateStatusQuatationByUser: "Quatation/updateStatusQuatationByUser",
  UpdateQuotationCustomPrice: "Quatation/UpdateQuotationCustomPrice",

  GetProductCategorywithsubcategory: "ProductCategory/GetProductCategorywithsubcategory",
  GetProductDetailBycategorysubcategory: "ProductDetail/GetProductDetailBycategorysubcategory",
  GetProductDetailById: "ProductDetail/GetProductDetailById",
  GetProductDetail: "ProductDetail/GetProductDetail",

  GetLoginDetails: "LoginDetail/GetLoginDetails",
  SaveLoginDetail: "LoginDetail/SaveLoginDetail",

  GetMenuDetailByTypeId: "RolePermission/GetMenuDetailByTypeId",


  GetProductCategory: "ProductCategory/GetProductCategory",
  SaveProductCategory: "ProductCategory/SaveProductCategory",
  DeleteProductCategoryById: "ProductCategory/DeleteProductCategoryById",

  SaveProductSubCategory: "ProductSubCategory/SaveProductSubCategory",
  GetProductSubCategory: "ProductSubCategory/GetProductSubCategory",
  DeleteProductSubCategoryById: "ProductSubCategory/DeleteProductSubCategoryById",
  GetProductSubCategoryByCategoryId: "ProductSubCategory/GetProductSubCategoryByCategoryId",

  SaveProductDetail: "ProductDetail/SaveProductDetail",
  DeleteProductDetailById: "ProductDetail/DeleteProductDetailById",

  GetProductSpecificationByProductId: "ProductSpecification/GetProductSpecificationByProductId",
  DeleteProductSpecificationById: "ProductSpecification/DeleteProductSpecificationById",
  SaveProductSpecification: "ProductSpecification/SaveProductSpecification",

  GetSpecification: "Specification/GetSpecification",

  GetProductImageByProductId: "ProductImage/GetProductImageByProductId",
  SaveProductImage: "ProductImage/SaveProductImage",
  DeleteProductImageById: "ProductImage/DeleteProductImageById",


  SaveCartDetail: "SaveCartDetail",
  GetCartDetailByLoginId: "GetCartDetailByLoginId",

  SaveProductOrder: "ProductOrder/SaveProductOrder",
  GetProductOrder: "ProductOrder/GetProductOrder",
  GetProductOrderByOrderId: "ProductOrder/GetProductOrderByOrderId",
  GetClubMembershipByLoginId: "ClubMembership/GetClubMembershipByLoginId",
  UpdateStatusClubMembership: "ClubMembership/UpdateStatusClubMembership",
  GetQuatationByLoginId: "Quatation/GetQuatationByLoginId",
  GetProductOrderByLoginId: "ProductOrder/GetProductOrderByLoginId",

  SentTOQuotation: "ProductOrder/SentTOQuotation",
  GetServiceDetailwithType: "CategoryType/GetServiceDetailwithType",
  GetServiceDetailById: "ServiceDetail/GetServiceDetailById",
  GetServiceDetail: "ServiceDetail/GetServiceDetail",
  GetCategoryType: "CategoryType/GetCategoryType",
  DeleteServiceDetailById: "ServiceDetail/DeleteServiceDetailById",
  SaveServiceDetail: "ServiceDetail/SaveServiceDetail",
  SaveServiceFeature: "ServiceFeature/SaveServiceFeature",
  DeleteServiceFeatureById: "ServiceFeature/DeleteServiceFeatureById",
  GetServiceFeature: "ServiceFeature/GetServiceFeature",
  GetServiceFeatureByServiceId: "ServiceFeature/GetServiceFeatureByServiceId",
  UpdateBookAppoinmentById: "BookAppoinment/UpdateBookAppoinmentById",

  SaveQuotationUserProblem: "QuotationUserProblem",
  GetQuotationUserProblem: "QuotationUserProblem",
  DeleteQuotationUserProblem: "QuotationUserProblem",
  UpdateQuotationUserProblem: "QuotationUserProblem",
  GetQuotationUserProblemById: "QuotationUserProblem",
};
